import { EuiFlexGroup, EuiFlexItem, EuiPanel, EuiSpacer, EuiLoadingSpinner, EuiButton } from "@elastic/eui"
import { Listado } from "./lista"
import {MenuLista} from "./menu"
import React, { forwardRef, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import "./styles.css"

export const Screen = forwardRef((props:any, ref:any) =>{

    const {data, dataUser, menu, actions, onSave, nombre} = props;

    let [selected,setSelected] = useState<any>([])
    const [checkAll, setCheckAll] = useState<any>(false)
    const [dataList, setDataList] = useState<any>([]);

    useEffect(()=> setSelected((oldArray:any) => dataUser && dataUser.lenght>0 ? [...oldArray,...dataUser] : []),[dataUser])
    
    useEffect(()=>{
        if(checkAll!==undefined){
            checkAll ?  setSelected((oldArray:any) => [...dataList.map((d:any)=> d)]) : setSelected([])
        }
    },[checkAll])

    const getLabel = (dataSociedad:any)=> `${dataSociedad.sociedad ? dataSociedad.sociedad : dataSociedad.label}`

    useEffect(()=>{
        if(data &&  data.length>0){
            let newData = data.map((d:any)=> {
                return {idSociedad:d.idSociedad, label: `${getLabel(d)}`, codPais: d.codPais, pais: d.pais, fechaBaja: d.fechaBaja}
            })

            setDataList((oldArray:any) => [...newData])
        }
    },[data])

    useEffect(()=>{
        if(dataUser &&  dataUser.length>0){
            let newData = dataUser.map((d:any)=> {
                return {idSociedad:d.idSociedad, label: `${getLabel(d)}`, codPais: d.codPais,  pais: d.pais, fechaBaja: d.fechaBaja}
            })

            setSelected((oldArray:any) => [...newData])
        }
    },[dataUser])

    const getSelected = () =>{ return selected
        // const ids = selected.map((s:any) => s.idSociedad);
        // return ids.join(';');
    }

    const onClickItem = (item:any) =>{
        const newItem = {...item}
        newItem.label = newItem.label
        setSelected((oldArray:any) => [...oldArray,newItem])
    }

    const onRemoveItem = (item:any) =>{
        setSelected((oldArray:any) => {
            const pos = selected.findIndex((f:any)=> f.idSociedad === item.idSociedad)
            oldArray.splice(pos,1)
            return [...oldArray]
        })
    }

    const getItemsNumber = useMemo(()=> data.length,[data])
    const getItemsSelect = useMemo(()=> selected.length,[selected])

    const getMenu:any = useMemo(() => 
    menu ? (
        <EuiFlexGroup style={{justifyContent: 'space-between'}}>
            <EuiFlexItem grow={false}>
            <EuiPanel style={{alignContent:'center', padding: '9px'}}>
                <MenuLista onChange={setCheckAll} checkAll={checkAll} itemsNumber={getItemsNumber} itemsSelection={getItemsSelect}/>
            </EuiPanel>
            </EuiFlexItem>
            {actions===true?
            <EuiFlexItem>
                <EuiFlexGroup justifyContent="flexEnd">
                    <EuiFlexItem grow={false}><EuiButton color='primary' style={{borderRadius: '0px'}} onClick={()=>onSave(getSelected())}>Asignar</EuiButton></EuiFlexItem>
                    <EuiFlexItem grow={false}><EuiButton color='danger' style={{borderRadius: '0px'}} onClick={()=>onSave(undefined)}>Cancelar</EuiButton></EuiFlexItem>
                </EuiFlexGroup>
            </EuiFlexItem>
            :null}
        </EuiFlexGroup>
    ) 
    : null,[checkAll,data,selected])

    const getTituloSociedades = {titulo:"SOCIEDADES", color: "default"}
    const getTituloSociedadesUsuario = {titulo:`SOCIEDADES ${nombre?'DE '+nombre.toUpperCase():'USUARIO'}`, color: "secondary"}
    
    return (
        <>
        {getMenu}
        <EuiSpacer size="m"/>
        <EuiFlexGroup style={{height:'95%'}}> 
        {dataList && dataList.length > 0 ?
        <>
            <EuiFlexItem style={{width: '45%'}}>
                <Listado titulo={getTituloSociedades} data={dataList} onClickItem={onClickItem} selected={selected} search/>
            </EuiFlexItem>
            <EuiFlexItem style={{width: '45%'}}>
                <Listado titulo={getTituloSociedadesUsuario} data={selected} actions={true} onRemoveItem={onRemoveItem}/>
            </EuiFlexItem>
        </>

        :    <EuiFlexItem style={{height:'200px', width:'100%', justifyContent:'center', alignItems: 'center'}}>
                <EuiLoadingSpinner size="xl" />
            </EuiFlexItem>}
        </EuiFlexGroup>
        </>
    )
})